import RequestAbstract from "./RequestAbstract";

export default class Files extends RequestAbstract {
    get link() {
        return this.links.files;
    }

    async downloadDocument(imageUrl, imageName) {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = imageName;
        link.click();
        URL.revokeObjectURL(blobUrl);
    }
}
